export default __webpack_public_path__ + "media/images/brands/expmessenger/logos/logo-dark-164x76-d84f441ad32abc9cdac8a48934dea493.png";